import type { HitResultItem } from 'vue-instantsearch';

export const calculateHitResultProductDiscount = (product : HitResultItem) => {
  return product.standardPrice && product.price && product.standardPrice > product.price
    ? product.standardPrice - product.price
    : 0;
};
